<template>
  <div class="home">
    <div v-if="!loading">
      <hotSiteBody />
      <hotSiteFooter />
    </div>
    <div v-else>
      <loadingComponent />
    </div>
  </div>
</template>

<script>
import hotSiteBody from "@/components/hotSiteBody.vue";
import loadingComponent from "@/components/loadingComponent.vue";
import hotSiteFooter from "@/components/hotSiteFooter.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";

export default {
  name: "HomeView",
  components: {
    hotSiteBody,
    loadingComponent,
    hotSiteFooter,
  },
  computed: {
    ...mapGetters(["getHotSite"]),
    siteType() {
      const host = window?.location?.host;
      if (host?.includes("try")) {
        return "parents";
      } else if (host?.includes("learn")) {
        return "professionals";
      } else if (host?.includes("heritage")) {
        return "heritage";
      } else if (host?.includes("go")) {
        return "leisure";
      } else {
        return "professionals";
      }
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  watch: {
    $route() {
      this.getHotSiteFromSlug();
    },
  },
  mounted() {
    this.getHotSiteFromSlug();
  },
  methods: {
    ...mapMutations(["setHotSite"]),
    getHotSiteFromSlug() {
      this.loading = true;
      axios
        .get(`https://cdn.contentful.com/spaces/8nqnktj51aoq/entries`, {
          params: {
            access_token: "njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k",
            content_type: "hotSite",
            "fields.slug": this.siteType, // Query by the slug field
          },
        })
        .then((response) => {
          if (response?.data?.items.length > 0) {
            this.setHotSite(response?.data?.items[0]);
            this.loading = false;
          }
          this.scrollToTop();
        })
        .catch(() => {});
    },
    capitalizeWords(str) {
      return str
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
